import Content from './content';
import type { ReactNode, Ref } from 'react';
import CSS from './Login.module.css';
import Button from '@CS/components/Button';
import FallbackLogoImage from '@CS/assets/logo.png';
import { useTranslation, useClassNames } from '@CS/hooks';

type LoginProps = {
  ref?: Ref<HTMLElement>;
  onLogin: () => void;
  topLogoSrc?: string;
  topLogoAlt?: string;
  mainLogoSrc?: string;
  mainLogoAlt?: string;
  cta?: ReactNode;
};

export const Login = ({
  ref,
  onLogin,
  topLogoSrc,
  topLogoAlt = "McDonald's Logo",
  mainLogoSrc = FallbackLogoImage,
  mainLogoAlt = "Logo ABZ",
  cta,
}: LoginProps) => {
  const { title, text, button } = useTranslation(Content);

  return (
    <section
      ref={ref}
      aria-label="Login"
      className={useClassNames([CSS.loginScreen, ref && CSS.hidden])}
    >
      {topLogoSrc && (
        <div className={CSS.header}>
          <img src={topLogoSrc} alt={topLogoAlt} className={CSS.mcdLogo} />
        </div>
      )}

      {mainLogoSrc && <img src={mainLogoSrc} alt={mainLogoAlt} className={CSS.abzLogo} />}

      <div className={CSS.infoContainer}>
        {title && <h3>{title}</h3>}
        <p>{text}</p>
      </div>

      {cta ?? <Button onClick={onLogin} text={button} />}
    </section>
  );
};
